import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})

export class FacebookService {

  constructor(private http: HttpClient,
    @Inject('BASE_API_URL') private apiURL:string) {}

  fbLogin(data) {
    return this.http.post(this.apiURL + '/api/users/verify_fb_login', data);
  }
}

